import React, { Component } from 'react';
import { getBrandsAndJurisdictions } from '../../../../../../../jurisdiction/redux/selectors';
import { connect } from 'react-redux';
import {
    addBrandToTeam,
    deleteBrandFromTeam
} from '../../../redux/jurisdictions/actions';
import * as _ from 'lodash';
import { ContentBox } from '../../../../../../../shared/content-box/ContentBox';
import { LabeledCheckbox } from '../../../../../../../shared/labeled-checkbox/LabeledCheckbox';
import { RadioOptions } from '../../../../../../../shared/radio-options/RadioOptions';
import {
    getTeamAddBrandLoading,
    getTeamAddJurisdictionLoading
} from '../../../redux/jurisdictions/selector';
import { JurisdictionMode } from '../TeamJurisdictions';
import { isSandboxJurisdiction } from '../../../../../../../shared/models/jurisdictions';
import { SandboxNote } from '../../../../../../../shared/sandbox/SandboxNote';
import TransparentButton from '../../../../../../../shared/button/transparent-button/TransparentButton';

class BrandsSelect extends Component {
    brandRadioOptions = [
        { name: 'All Brands', value: JurisdictionMode.All },
        { name: 'Custom', value: JurisdictionMode.Custom }
    ];

    constructor(props) {
        super(props);

        this.state = {
            brandMode: this.getBrandMode(props.jurisdiction.brandIds)
        };
    }

    hasAllBrands = brands =>
        _.find(brands, brand => brand === JurisdictionMode.All);

    getBrandMode = teamBrands => {
        if (!teamBrands) {
            return JurisdictionMode.Custom;
        }

        if (this.hasAllBrands(teamBrands)) {
            return JurisdictionMode.All;
        } else if (teamBrands.length > 0) {
            return JurisdictionMode.Custom;
        }
    };

    handleBrandModeChange = brandMode => {
        this.setState(
            {
                ...this.state,
                brandMode
            },
            () => this.addBrand()
        );
    };

    addBrand = brandId => {
        const { brandMode } = this.state;
        const { addBrand, teamId, jurisdiction } = this.props;

        if (brandMode === JurisdictionMode.All) {
            _.isFunction(addBrand) &&
                addBrand(teamId, jurisdiction.code, JurisdictionMode.All);
        } else if (brandMode === JurisdictionMode.Custom && brandId) {
            _.isFunction(addBrand) &&
                addBrand(teamId, jurisdiction.code, brandId);
        }
    };

    deleteBrand = brandId => {
        const { teamId, jurisdiction, deleteBrand } = this.props;
        _.isFunction(deleteBrand) &&
            deleteBrand(teamId, jurisdiction.code, brandId);
    };

    handleBrandCodeChange = brandId => {
        if (this.isBrandSelected(brandId)) {
            this.deleteBrand(brandId);
        } else {
            this.addBrand(brandId);
        }
    };

    getTeamBrandIds = () => {
        const { jurisdiction } = this.props;

        return (jurisdiction && jurisdiction.brandIds) || [];
    };

    getBrandsForJurisdiction = (brands, jurisdiction) =>
        brands.filter(brand => brand.jurisdiction === jurisdiction.code);

    isBrandSelected = id => {
        const teamBrands = this.getTeamBrandIds();

        if (this.hasAllBrands(teamBrands)) {
            return true;
        }
        // The team's brand ids arrive as strings, the brands' own ids as numbers.
        return !!teamBrands.find(currId => `${currId}` === `${id}`);
    };

    showBrandSelection = () => this.state.brandMode === JurisdictionMode.Custom;

    isSandbox = () =>
        isSandboxJurisdiction(
            _.find(this.props.jurisdictions, {
                code: this.props.jurisdiction.code
            })
        );

    giveAccessToAllBrands = () => {
        const { addBrand, teamId, jurisdiction } = this.props;

        _.isFunction(addBrand) &&
            addBrand(teamId, jurisdiction.code, JurisdictionMode.All);
    };

    /*
      A sandbox is given to a team for all its brands and for no fewer. Its brands are its runs: they are few, they are deleted, and
      a new one is made for every run, so a team given some of them would lose them, and never see the next. A mapping with all
      brands also covers the runs made later. A team that holds some runs only (made outside this editor) is told, and can be given all.
    */
    renderSandbox() {
        const { jurisdiction, jurisdictionLoading, brandLoading } = this.props;
        const allBrands = !!this.hasAllBrands(this.getTeamBrandIds());

        return (
            <ContentBox
                title={`Brands - ${jurisdiction.code}`}
                content={
                    <div className={'sandbox-brands'}>
                        <SandboxNote>
                            {`${jurisdiction.code} is a sandbox: a team has access to it for all its brands, which also covers the runs that are made in it later.`}
                        </SandboxNote>
                        {!allBrands && (
                            <div className={'sandbox-some-brands'}>
                                This team has access to some of the runs of the
                                sandbox only, and will not see the next ones.
                                <TransparentButton
                                    disabled={
                                        jurisdictionLoading || brandLoading
                                    }
                                    onClick={this.giveAccessToAllBrands}
                                >
                                    Give access to all brands
                                </TransparentButton>
                            </div>
                        )}
                    </div>
                }
            />
        );
    }

    render() {
        const {
            brands,
            jurisdiction,
            jurisdictionLoading,
            brandLoading,
            showBrand
        } = this.props;
        const isLoading = jurisdictionLoading || brandLoading;
        const sandbox = this.isSandbox();
        const brandsPerJurisdiction =
            brands &&
            jurisdiction &&
            this.getBrandsForJurisdiction(brands, jurisdiction);

        return (
            <div className={'brands-select-container'}>
                {showBrand && sandbox && this.renderSandbox()}
                {showBrand && !sandbox && (
                    <ContentBox
                        title={`Brands - ${jurisdiction.code}`}
                        content={
                            <div className={'jurisdiction-select-row'}>
                                <RadioOptions
                                    disabled={isLoading}
                                    handleChange={this.handleBrandModeChange}
                                    value={this.state.brandMode}
                                    options={this.brandRadioOptions}
                                />

                                {this.showBrandSelection() &&
                                    brandsPerJurisdiction && (
                                        <div>
                                            {brandsPerJurisdiction.map(
                                                brand => (
                                                    <LabeledCheckbox
                                                        key={brand.name}
                                                        text={brand.name}
                                                        disabled={isLoading}
                                                        onChange={() =>
                                                            this.handleBrandCodeChange(
                                                                brand.id
                                                            )
                                                        }
                                                        checked={this.isBrandSelected(
                                                            brand.id
                                                        )}
                                                    />
                                                )
                                            )}
                                        </div>
                                    )}
                            </div>
                        }
                    />
                )}
            </div>
        );
    }
}
const mapStateToProps = state => {
    const { brands, jurisdictions } = getBrandsAndJurisdictions(state);

    return {
        brands,
        jurisdictions,
        jurisdictionLoading: getTeamAddJurisdictionLoading(state),
        brandLoading: getTeamAddBrandLoading(state)
    };
};
const mapDispatchToProps = dispatch => ({
    addBrand: (teamId, jurisdictionCode, brandId) =>
        dispatch(addBrandToTeam({ teamId, jurisdictionCode, brandId })),
    deleteBrand: (teamId, jurisdictionCode, brandId) =>
        dispatch(deleteBrandFromTeam({ teamId, jurisdictionCode, brandId }))
});

export default connect(mapStateToProps, mapDispatchToProps)(BrandsSelect);
